import { Component, Prop } from 'vue-property-decorator'
import { CreateElement } from 'vue'

import Member from '@src/data/member'
import { Body2, Subtitle1 } from '@src/elements/typography/typography'
import { Icon } from '@src/elements/icon/icon'
import { Input } from '@src/elements/input/input'
import { OptionGroup } from '@src/elements/select/option-group'
import { Popover } from '@src/components/popover/popover'

@Component
export class RecipientsInput extends Input {

  @Prop({ required: true, default: [] })
  allMembers: Member[]

  @Prop({ required: true, default: [] })
  recipients: (Member | string)[]

  @Prop({ required: true })
  alertRemoved: (value: string) => void

  @Prop({ required: true })
  memberAdded: (member: Member) => void

  @Prop({ required: true })
  memberRemoved: (member: Member) => void

  searchedText: string = ''
  showResults: boolean = true

  render (h: CreateElement) {

    let styleClasses = [
      ...this.elementStyles,
      ...this.inputStyles
    ]

    return <div class='container'>
      {this.renderElement(h, styleClasses, this.disabled, [
        this.renderLabel(h),
        this.renderInput(h)
      ])}
      {this.renderMemberOptions(h)}
    </div>
  }

  protected get inputStyles () {
    let styleClasses = ['input recipients-input-container']

    if (this.hasFocus) {
      styleClasses.push('focus')
    }

    if (this.searchedText || this.recipients.length > 0) {
      styleClasses.push('valid')
    }

    return styleClasses
  }

  protected renderInput (h: CreateElement) {
    const recipients = this.recipients.map((recipient: Member | string) => {
      const text = typeof recipient === 'string' ? this.$t(`PAGE.MESSAGING.ALERTS.${recipient.toUpperCase()}`) : recipient.fullName
      return <Body2 class='recipient'>
        {text}
        <Icon name='util/close-circled' click={() => this.removeRecipient(recipient)} class='remove-btn' />
      </Body2>
    })

    return <div class='input-container recipients-input'>
      {recipients}
      <input ref='input' type='text' value={this.searchedText}
             onFocus={this.onFocus} onBlur={this.onFocus}
             onKeydown={this.onKeydown} onInput={this.onInput} />
    </div>
  }

  protected renderLabel (h: CreateElement) {
    return <label class='input-description'>{this.$t('PAGE.MESSAGING.TO')}</label>
  }

  protected renderMemberOptions (h: CreateElement) {
    let foundMembers: any[] = []

    if (this.searchedText) {
      foundMembers = this.allMembers
        .filter(member => member.fullName.toLowerCase().indexOf(this.searchedText.toLowerCase().trim()) >= 0 && !this.recipients.includes(member))
        .map(member => {
          return <div onClick={() => this.selectMember(member)} class='member-option'>
            <Subtitle1>{member.fullName}</Subtitle1>
          </div>
        })
    }

    if (!this.showResults || foundMembers.length === 0) {
      return null
    }

    return <Popover>
      <OptionGroup>
        {foundMembers}
      </OptionGroup>
    </Popover>
  }

  protected searchMember (value: string) {
    this.searchedText = value.trimLeft()
    this.showResults = this.searchedText.length > 0
  }

  protected selectMember (member) {
    this.searchedText = ''
    this.memberAdded(member)
  }

  protected removeRecipient (recipient: Member | string) {
    if (typeof recipient === 'string') {
      this.alertRemoved(recipient)
    } else {
      this.memberRemoved(recipient)
    }
  }

  protected onInput ($event) {
    this.searchMember($event.target.value)
  }
}
